import { render, staticRenderFns } from "./RenewPW.vue?vue&type=template&id=4b8d5b7f&"
import script from "./RenewPW.vue?vue&type=script&lang=js&"
export * from "./RenewPW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports